import React from 'react';
import createSvgIcon from '../createNewIcon.js';
const CreditCard = createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("rect", { x: "4", y: "15.527", width: "7", height: "2" }),
    React.createElement("path", { d: "M0,0.828v4.2v2v2.2v2v10.499h24V11.229v-2v-2.2v-2v-4.2H0z M22,19.728H2v-8.499h20V19.728z M22,9.228H2v-2.2h20V9.228z M2,5.028v-2.2h20v2.2H2z" }),
    React.createElement("rect", { x: "17", y: "15.527", width: "3", height: "2" })), 'CreditCard');
export default CreditCard;
